import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { lazy, Suspense, useEffect } from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import Home from "@/pages/Home";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";
import NotFound from "@/pages/NotFound";
import { routes } from "@/business-config";
const OriginalHome = lazy(() => import("@/pages/original/Home"));

function RouteScroll() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    let frame;
    let attempts = 0;
    const scroll = () => {
      let anchor = hash.slice(1);
      try {
        anchor = decodeURIComponent(anchor);
      } catch {}
      const target = anchor && document.getElementById(anchor);
      if (anchor && !target && attempts < 60) {
        attempts += 1;
        frame = requestAnimationFrame(scroll);
        return;
      }
      document.getElementById("main")?.focus({ preventScroll: true });
      if (target)
        target.scrollIntoView({
          behavior: pathname.startsWith("/original") ? "smooth" : "instant",
          block: "start",
        });
      else window.scrollTo({ top: 0, behavior: "instant" });
    };
    frame = requestAnimationFrame(scroll);
    return () => cancelAnimationFrame(frame);
  }, [pathname, hash]);
  return null;
}
function LegacySection({ section }) {
  const { hash } = useLocation();
  const anchor =
    hash === "#inspectie-defectiuni" ? "#diagnosticare-auto" : hash;
  return <Navigate to={"/" + (anchor || "#" + section)} replace />;
}
function LegalFooter() {
  const { pathname } = useLocation();
  if (pathname === "/") return null;
  return pathname.startsWith("/original") ? (
    <Footer basePath="/original" />
  ) : (
    <Footer />
  );
}
function SiteHeader() {
  const { pathname } = useLocation();
  if (pathname === "/") return null;
  return pathname.startsWith("/original") ? (
    <Header basePath="/original" />
  ) : (
    <Header />
  );
}
export default function App() {
  return (
    <BrowserRouter>
      <a href="#main" className="skip-link">
        Sari la conținut
      </a>
      <RouteScroll />
      <SiteHeader />
      <main id="main" tabIndex={-1}>
        <Suspense
          fallback={
            <div className="original-route-loading" role="status">
              <span className="sr-only">Se încarcă</span>
            </div>
          }
        >
          <Routes>
            <Route path={routes.home} element={<Home />} />
          <Route
            path={routes.services}
            element={<LegacySection section="servicii" />}
          />
          <Route
            path={routes.about}
            element={<Navigate to="/#despre-service" replace />}
          />
          <Route
            path={routes.contact}
            element={<Navigate to="/#contact" replace />}
          />
          <Route
            path={routes.process}
            element={<Navigate to="/#despre-service" replace />}
          />
          <Route
            path={routes.faq}
            element={<Navigate to="/#contact" replace />}
          />
          <Route path={routes.privacy} element={<Privacy />} />
          <Route path={routes.cookies} element={<Cookies />} />
          <Route path="/original" element={<OriginalHome />} />
          <Route path="/original/servicii" element={<Navigate to="/original#servicii" replace />} />
          <Route path="/original/despre-noi" element={<Navigate to="/original#atelier" replace />} />
          <Route path="/original/contact" element={<Navigate to="/original#contact" replace />} />
          <Route
            path="/original/procesul-de-lucru"
            element={<Navigate to="/original#atelier" replace />}
          />
          <Route
            path="/original/intrebari-frecvente"
            element={<Navigate to="/original#contact" replace />}
          />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      <LegalFooter />
    </BrowserRouter>
  );
}
